import { Injectable, inject } from '@angular/core';
import { DBService } from './db-service';
import { Observable } from 'rxjs';
import { InspectionInformationDto } from 'src/app/dtos/inspectionInformationDto';

@Injectable()
export class InspectionInformationDBService {
  private dbService = inject(DBService);

  private readonly idInspectionInformation = 'inspection_information_';

  public getInspectionInformation(
    inspectionKey: string | null,
  ): Observable<InspectionInformationDto> {
    return this.dbService.getById<InspectionInformationDto>(this.getId(inspectionKey));
  }

  public putInspectionInformation(
    inspectionInformation: InspectionInformationDto,
  ): Observable<string> {
    return this.dbService.put<InspectionInformationDto>(
      inspectionInformation,
      this.getId(inspectionInformation.inspectionKey),
    );
  }

  private getId(inspectionKey: string | null): string {
    return `${this.idInspectionInformation}${inspectionKey}`;
  }
}
